import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './LogoCarousel.module.scss'

const Row1: React.FC = () => {
  return (
    <>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo4.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo10.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo1.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo7.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo12.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo8.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo2.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo6.png' className={styles.image} alt=''
        />
      </div>
    </>
  )
}

export default Row1
